// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ValuePropositionSection_section__XffIN {
  position: relative;
  z-index: 2;
  margin-top: calc(var(--space-xxl) * 2);
  padding-bottom: var(--space-xxl);
}

.ValuePropositionSection_layout__S48aq {
  display: grid;
  grid-template-columns: minmax(0, 0.92fr) minmax(0, 1.28fr);
  gap: var(--space-xl);
  align-items: start;
  padding-top: var(--space-lg);
}

.ValuePropositionSection_content__CPuqz {
  max-width: 34rem;
}

.ValuePropositionSection_label__wivBG {
  color: var(--color-text-subtle);
  font-size: var(--font-size-small);
  margin-bottom: var(--space-sm);
}

.ValuePropositionSection_headline__kP7m7 {
  font-size: var(--font-size-xlarge);
  font-weight: var(--font-weight-bold);
  line-height: 1.05;
  margin-bottom: var(--space-sm);
}

.ValuePropositionSection_description__cbquN {
  font-size: var(--font-size-base);
  line-height: var(--line-height-base);
  color: var(--color-text);
}

.ValuePropositionSection_button__iUkKy {
  margin-top: var(--space-lg);
  background-color: var(--color-text);
  color: var(--color-background);
  border: none;
  border-radius: 25px;
  padding: var(--space-xs) var(--space-sm);
  font-size: var(--font-size-small);
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.ValuePropositionSection_button__iUkKy:hover {
  background-color: var(--color-text-subtle);
  color: var(--color-background);
}

.ValuePropositionSection_featureGrid__JEwdl {
  display: grid;
  grid-template-columns: repeat(2, minmax(16rem, 1fr));
  gap: calc(var(--space-md) * 0.9);
}

.ValuePropositionSection_featureCard__5YWAT {
  min-height: 10.5rem;
  padding: calc(var(--space-md) * 0.92);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.02);
  text-align: left;
  transition: border-color 0.3s ease;
}

.ValuePropositionSection_featureCard__5YWAT:hover {
  border-color: rgba(77, 163, 255, 0.65);
}

.ValuePropositionSection_featureHeader__PETuv {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-bottom: var(--space-xs);
}

.ValuePropositionSection_iconWrap__XgLgC {
  flex: 0 0 auto;
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 0.8rem;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
}

.ValuePropositionSection_icon__HndBe {
  color: var(--color-text);
  font-size: 1rem;
}

.ValuePropositionSection_featureTitle__98JEK {
  font-size: var(--font-size-medium);
  margin-bottom: 0;
  line-height: 1.2;
}

.ValuePropositionSection_featureDescription__154G9 {
  font-size: var(--font-size-small);
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.78);
}

@media (max-width: 900px) {
  .ValuePropositionSection_layout__S48aq {
    grid-template-columns: 1fr;
  }

  .ValuePropositionSection_content__CPuqz {
    max-width: none;
  }
}

@media (max-width: 640px) {
  .ValuePropositionSection_featureGrid__JEwdl {
    grid-template-columns: 1fr;
  }

  .ValuePropositionSection_featureCard__5YWAT {
    min-height: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ValuePropositionSection.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,iCAAiC;EACjC,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".section {\n  position: relative;\n  z-index: 2;\n  margin-top: calc(var(--space-xxl) * 2);\n  padding-bottom: var(--space-xxl);\n}\n\n.layout {\n  display: grid;\n  grid-template-columns: minmax(0, 0.92fr) minmax(0, 1.28fr);\n  gap: var(--space-xl);\n  align-items: start;\n  padding-top: var(--space-lg);\n}\n\n.content {\n  max-width: 34rem;\n}\n\n.label {\n  color: var(--color-text-subtle);\n  font-size: var(--font-size-small);\n  margin-bottom: var(--space-sm);\n}\n\n.headline {\n  font-size: var(--font-size-xlarge);\n  font-weight: var(--font-weight-bold);\n  line-height: 1.05;\n  margin-bottom: var(--space-sm);\n}\n\n.description {\n  font-size: var(--font-size-base);\n  line-height: var(--line-height-base);\n  color: var(--color-text);\n}\n\n.button {\n  margin-top: var(--space-lg);\n  background-color: var(--color-text);\n  color: var(--color-background);\n  border: none;\n  border-radius: 25px;\n  padding: var(--space-xs) var(--space-sm);\n  font-size: var(--font-size-small);\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.button:hover {\n  background-color: var(--color-text-subtle);\n  color: var(--color-background);\n}\n\n.featureGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(16rem, 1fr));\n  gap: calc(var(--space-md) * 0.9);\n}\n\n.featureCard {\n  min-height: 10.5rem;\n  padding: calc(var(--space-md) * 0.92);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 1rem;\n  background: rgba(255, 255, 255, 0.02);\n  text-align: left;\n  transition: border-color 0.3s ease;\n}\n\n.featureCard:hover {\n  border-color: rgba(77, 163, 255, 0.65);\n}\n\n.featureHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  margin-bottom: var(--space-xs);\n}\n\n.iconWrap {\n  flex: 0 0 auto;\n  width: 2.35rem;\n  height: 2.35rem;\n  border-radius: 0.8rem;\n  background: rgba(255, 255, 255, 0.06);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon {\n  color: var(--color-text);\n  font-size: 1rem;\n}\n\n.featureTitle {\n  font-size: var(--font-size-medium);\n  margin-bottom: 0;\n  line-height: 1.2;\n}\n\n.featureDescription {\n  font-size: var(--font-size-small);\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.78);\n}\n\n@media (max-width: 900px) {\n  .layout {\n    grid-template-columns: 1fr;\n  }\n\n  .content {\n    max-width: none;\n  }\n}\n\n@media (max-width: 640px) {\n  .featureGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .featureCard {\n    min-height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `ValuePropositionSection_section__XffIN`,
	"layout": `ValuePropositionSection_layout__S48aq`,
	"content": `ValuePropositionSection_content__CPuqz`,
	"label": `ValuePropositionSection_label__wivBG`,
	"headline": `ValuePropositionSection_headline__kP7m7`,
	"description": `ValuePropositionSection_description__cbquN`,
	"button": `ValuePropositionSection_button__iUkKy`,
	"featureGrid": `ValuePropositionSection_featureGrid__JEwdl`,
	"featureCard": `ValuePropositionSection_featureCard__5YWAT`,
	"featureHeader": `ValuePropositionSection_featureHeader__PETuv`,
	"iconWrap": `ValuePropositionSection_iconWrap__XgLgC`,
	"icon": `ValuePropositionSection_icon__HndBe`,
	"featureTitle": `ValuePropositionSection_featureTitle__98JEK`,
	"featureDescription": `ValuePropositionSection_featureDescription__154G9`
};
export default ___CSS_LOADER_EXPORT___;
